import type { StaffLevel } from "@/types/staff/api-types/staff-level-types";

export const getStaffLevelFormValues = (staffLevel?: StaffLevel) => {
  return {
    name: staffLevel?.name || "",
  };
};